import { userManager } from '~/utility/BinSentry-ui-utility';
import { html, LitEntity, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { sessionStyles } from '../styles/session-styles';
import '../common/bn-logo';

class LogoutPage extends LitEntity {
  constructor() {
    super();
    this.state = 'signingout';
  }

  static get properties() {
    return {
      state: { type: String, attribute: false },
      message: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, sessionStyles];
  }

  render() {
    return html`
      <div class="boxes">
        <div class="box">
          <bn-logo></bn-logo>
          <bn-flash id="flash" .banners="${this.message ? [{ content: this.message, type: this.state === 'failed' ? 'critical' : 'success' }] : []}"></bn-flash>
          ${renderIf(this.state === 'signingout', html`<bn-loading loading-text="Signing out..."></bn-loading>`)}
          ${renderIf(this.state === 'failed', html`
            <div>
              <a href="/login">Return to sign-in</a>
            </div>
          `)}
        </div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    userManager.logout().catch(err => {
      this.message = err.message || `${err}`;
      this.state = 'failed';
    });
  }
}

window.customElements.define('logout-page', LogoutPage);
